// var api_url = 'https://kult.lyxelandflamingotech.in/api/check-inventory';
var api_url = "https://sap.kenstar.in/api/check-inventory-new";
function addProductToCart(id, card, hidePopup, qty) {
  // var xhttp = new XMLHttpRequest();
  $.ajax({
    url: "/cart/add",
    type: "post",
    data: { id: id, quantity: qty ? qty : 1 },
    success: function (response) {
      $cart = $(response);
      let drawer = $("<div />").append(response).find("#slideCart").html();
      let count = $("#headerCartCount", $cart).text();
      $("#slideCart").html(drawer);
      $(".cartCount").html(count);
      toggleSlideCart();
      $(card).css("opacity", "1");
      $('[data-type="add-to-cart-form"]').css("opacity", 1);
      if (hidePopup === true) {
        $("#location-modal").hide();
      }
      // xhttp.open("POST", "/cart/clear.js", true);
      // xhttp.send();
      crietoCart();
    },
    error: function (err) {
      alert("There was a Problem in Adding Product in Cart");
      $(card).css("opacity", "1");
    },
  });
}
function getLocalPincode() {
  var pincode = getCookie("pincode");
  //var deliver = getCookie('deliver');
  var status = false;
  $(".pincode").val(pincode);
  /*
  if(pincode){
    if(deliver == 1){
      $('.deliverAtPincode').html('<div class="success">'+deliverMsg+'</div>');
      status = true;
    }else{
      $('.deliverAtPincode').html('<div class="error">'+notDeliverMsg+'</div>')
    }
  }
  */
  return status;
}
$(".checkDelivery").submit(function (e) {
  e.preventDefault();
  var pincode = $("#pincode").val();
  // var type = $('[name="type"]').val();
  products[0].pincode = pincode;
  //products.sku_id = $('{{ product.sku }}')
  //products.qty = $('#pdpQty').val();
  //console.log('sdfdsfd')

  var $btn = $(".cartCheckout", this);
  var $form = $(this);
  $btn.attr("disabled", 1).html("Please Wait...");
  $(".cart-order-item").removeClass("invalid");
  $(".response", $form).html("");
  setCookie("pincode", pincode, 1);

  async function checkDeliverySKUCheckout(){
    let isValid = true;
    var invalid = [];
    for(let i = 0;i<products.length;i++){
      let p = products[i];
      console.log(p)
      let sku = document.querySelector(`[data-sku="${p.sku_id}"]`)
      p.pincode = pincode;
      let response = await checkSKUDelivery(p);
      if(response == true || response === true || response == 'true'){
        sku.classList.remove('invalid');
      }else{
        sku.classList.add('invalid');
        isValid = false;
        invalid.push(p.sku_id);
      }
    }
    
    if (isValid == true) {
      //setCookie('deliver',1,1);
      beginCheckout();
      window.location.href = "/checkout";
    } else {
      $(".response", $form).html(
        '<div class="error">Red marked products not servicable or out of stock at your location.</div>'
      );
      //setCookie('deliver',0,1);
    }
    $btn.removeAttr("disabled").html("Checkout");

  }
  checkDeliverySKUCheckout()
  return false;
  $.ajax({
    url: api_url,
    type: "post",
    cache: false,
    data: products[0],
    success: function (response) {
      var isValid = true;
      var invalid = [];

      //for (const obj of response.data) {
      // Loop through the keys and values of each object
      for (let [key, value] of Object.entries(response.data)) {
        console.log(value)
        if (value == 0 || !value) {
          key = key.replace(/\//g,'_')
          invalid.push(key);
          $(".sku_" + key.replace(/ /g, "_")).addClass("invalid");
          isValid = false;
        }
      }
      //}
      if (isValid == true) {
        //setCookie('deliver',1,1);
        beginCheckout();
        window.location.href = "/checkout";
      } else {
        $(".response", $form).html(
          '<div class="error">Red marked products not servicable or out of stock at your location.</div>'
        );
        //setCookie('deliver',0,1);
      }
      $btn.removeAttr("disabled").html("Checkout");
    },
    error: function (err) {
      $(".response", $form).html(
        '<div class="error">Server Error!! Please try again later.</div>'
      );
      $btn.removeAttr("disabled").html("Checkout");
      //setCookie('deliver',0);
    },
  });
});
async function checkSKUDelivery(product){
   let isValid = true;
    let response = await fetch(`${api_url}?${new URLSearchParams(product).toString()}`,{
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: "",
    });
    if(!response.ok){
      return false;
    }
    response = await response.json();
    console.log('response',response)
    for (const [key, value] of Object.entries(response.data)) {
      if (value == 0 || !value) {
        isValid = false;
      }
    }
    return isValid;
}

$("#popupPincodeForm").submit(function (e) {
  e.preventDefault();
  console.log(this);
  var value = $(".pincode", this).val().trim();
  var sku = $('[name="sku"]', this).val();
  var type = $('[name="type"]', this).val();
  var variant = $('[name="id"]', this).val();
  var qty = $('[name="quantity"]', this).val();
  $("button", this).attr("disabled", 1).css("opacity", 0.2);
  var form = this;
  var id = $(this).attr("id");

  $(".response", form).html("");
  setCookie("pincode", value, 1);
  var product = {};

  product.pincode = value;
  //product[sku] = {'qty':qty};
  product.sku_id = sku;
  product.qty = qty;
  product.type = type;


  $.ajax({
    url: api_url,
    type: "post",
    cache: false,
    data: product,
    success: function (response) {
      var isValid = true;

      $("button", this).removeAttr("disabled").css("opacity", 1);
      //for (const obj of response.data) {
      // Loop through the keys and values of each object
      for (const [key, value] of Object.entries(response.data)) {
        if (value == 0 || !value) {
          isValid = false;
        }
      }
      //}

      if (isValid == true) {
        setCookie("deliver", 1, 1);
        addProductToCart(variant, form, true, qty);
        $("button", form).removeAttr("disabled").css("opacity", 1);
      } else {
        $(".response", form).html(
          '<div class="error">' + notDeliverMsg + "</div>"
        );
        setCookie("deliver", 0, 1);
        $("button", form).removeAttr("disabled").css("opacity", 1);
      }
    },
    error: function (err) {
      $("button", form).removeAttr("disabled").css("opacity", 1);
      $(".response", form).html(
        '<div class="error">Server Error!! Please try again later.</div>'
      );
      setCookie("deliver", 0, 1);
    },
  });
});
$("#popup-close").on("click", function (e) {
  e.preventDefault();
  $("#location-modal").hide();
  $('[data-type="add-to-cart-form"]').css("opacity", 1);
});
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
